import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Button, Alert, Row, Col } from 'reactstrap';
import { AvForm, AvGroup, AvField } from 'availity-reactstrap-validation';
import i18n from '../i18next';

import { MESSAGE_LEVEL_ERROR } from "../utils/Constants";
import { changeLoginPassword, clearMessage, resetPassword } from '../actions';
import { getAllUrlParams } from "../utils/CommonUtils";
import MenuuLogoSVG from "../images/MenuuLogoSVG";

class ResetPassScreen extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			newPassword: '',
			repeatNewPassword: '',
			secretKey: ''
		};

		this.changeState = this.changeState.bind(this);
	}

	componentWillMount() {
		const url = this.props.location.search;
		const queryParams = getAllUrlParams(url);
		this.state.email = queryParams.email;
		this.state.secretKey = queryParams.secretKey;
	}

	changeState({ target }) {
		this.setState({
			[target.name]: target.value
		})
	}

	resetPassword() {
		this.props.resetPassword(this.state);
	}

	renderMessage() {
		const { alertStyle } = styles;

		if (this.props.message.text !== undefined && this.props.message.text !== null && this.props.message.text !== '') {
			// Dismiss the message after 3 seconds because if you don't close it,  it appear again after you logged in.
			const errorMessage = (this.props.message.level === MESSAGE_LEVEL_ERROR);

			if (errorMessage) {
				setTimeout(() => {
					this.props.clearMessage();
				}, 3000);
			}

			const dismiss = this.props.clearMessage.bind(this);
			const color = (errorMessage) ? 'danger' : 'success';

			return (
				<div style={alertStyle}>
					<Alert color={color} toggle={dismiss}>
						{this.props.message.text}
					</Alert>
				</div>
			);
		} else {
			return (
				<div></div>
			);
		}
	}

	render() {
		const { loginScreenContainer, formContainer, logoContainer, loginButton, logoImage, sloganText, column,logoSvg } = styles;

		return (
			<Container style={loginScreenContainer}>
				<Row>
					<Col style={column}>
						<div style={logoContainer}>
							<span style={logoSvg}><MenuuLogoSVG width={150} height={60} fill={'#000'} /></span>
							<p style={sloganText}>{i18n.t('screens:loginScreen.heading')}</p>
						</div>
						<div style={formContainer}>
							<AvForm onValidSubmit={() => this.resetPassword()}>
								<AvGroup>
									<AvField name="newPassword" label={i18n.t('screens:profileScreen.newPass')} type="password" minLength={6}
										value={this.state.newPassword}
										onChange={this.changeState}
										required
										errorMessage={i18n.t('common:validations.errorMsg')}
										validate={{
											minLength: {
												value: 6,
												errorMessage: i18n.t('common:validations.passLength')
											}
										}}
									/>
								</AvGroup>
								<AvGroup>
									<AvField name="repeatNewPassword" label={i18n.t('screens:profileScreen.repeatNewPass')} type="password"
										value={this.state.repeatNewPassword}
										onChange={this.changeState} required
										errorMessage={i18n.t('common:validations.errorMsg')}
										validate={{
											match: {
												value: 'newPassword',
												errorMessage: i18n.t('common:validations.matchPasswords')
											}
										}}
									/>
								</AvGroup>
								<Button style={loginButton} color="danger" >{i18n.t('screens:resetPassScreen.resetPassBtn')}</Button>
							</AvForm>
						</div>
					</Col>
				</Row>
				{this.renderMessage()}
			</Container>
		);
	}
}

const mapStateToProps = state => {
	return {
		message: state.message
	};
};

export default connect(mapStateToProps, { resetPassword, changeLoginPassword, clearMessage })(ResetPassScreen);

let styles = {
	formContainer: {
		backgroundColor: '#cccccc8c',
		padding: 50,
		width: 400,
		margin: 'auto'
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: 35
	},
	logoContainer: {
		display: 'flex',
		flexDirection: 'column',
		padding: '0px 50px'
	},
	loginButton: {
		width: '100%',
		marginBottom: 10
	},
	logoImage: {
		paddingBottom: 10,
		alignSelf: 'center',
		height: '100%'
	},
	sloganText: {
		marginBottom: 20
	},
	alertStyle: {
		position: 'fixed',
		top: '70px',
		left: '0',
		right: '0',
		width: '400px',
		height: '50px',
		marginLeft: 'auto',
		marginRight: 'auto'
	},
	loginScreenContainer: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	logoSvg: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}
}


// WEBPACK FOOTER //
// ./src/components/ResetPassScreen.js